import moment from 'moment-timezone';

// Cấu hình locale tiếng Việt cho moment
moment.updateLocale('vi', {
  months: [
    'Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu',
    'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai'
  ],
  monthsShort: [
    'Th1', 'Th2', 'Th3', 'Th4', 'Th5', 'Th6',
    'Th7', 'Th8', 'Th9', 'Th10', 'Th11', 'Th12'
  ],
  weekdays: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
  weekdaysShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  weekdaysMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM [năm] YYYY',
    LLL: 'D MMMM [năm] YYYY HH:mm',
    LLLL: 'dddd, D MMMM [năm] YYYY HH:mm'
  },
  calendar: {
    sameDay: '[Hôm nay lúc] LT',
    nextDay: '[Ngày mai lúc] LT',
    nextWeek: 'dddd [tuần tới lúc] LT',
    lastDay: '[Hôm qua lúc] LT',
    lastWeek: 'dddd [tuần trước lúc] LT',
    sameElse: 'L'
  },
  relativeTime: {
    future: 'trong %s',
    past: '%s trước',
    s: 'vài giây',
    ss: '%d giây',
    m: 'một phút',
    mm: '%d phút',
    h: 'một giờ',
    hh: '%d giờ',
    d: 'một ngày',
    dd: '%d ngày',
    M: 'một tháng',
    MM: '%d tháng',
    y: 'một năm',
    yy: '%d năm'
  },
  dayOfMonthOrdinalParse: /\d{1,2}/,
  ordinal: function (number) {
    return number;
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  }
});

// Set locale mặc định là tiếng Việt
moment.locale('vi');

// Set timezone mặc định là Việt Nam
moment.tz.setDefault('Asia/Ho_Chi_Minh');

// Export moment đã được cấu hình
export default moment;

// Utility functions để xử lý date/time an toàn
export const createMoment = (date) => {
  if (!date) return moment().tz('Asia/Ho_Chi_Minh');
  return moment(date).tz('Asia/Ho_Chi_Minh');
};

export const formatDate = (date, format = 'DD/MM/YYYY') => {
  return createMoment(date).format(format);
};

export const formatDateTime = (date, format = 'DD/MM/YYYY HH:mm:ss') => {
  return createMoment(date).format(format);
};

// Tạo moment object mà không bị mutate
export const safeClone = (momentObj) => {
  return momentObj ? momentObj.clone() : moment();
};

// Tạo moment với timezone Việt Nam
export const vnMoment = (date) => {
  return moment(date).tz('Asia/Ho_Chi_Minh');
}; 